import axiosInstance from '../utils/api-util/utilApi'
import {
  ICheckVerificationload,
  IDecisionPayload,
  IGetFileDetailPayload,
  IGetFileDetailResponse,
  IGetIssuedCheckFielPayload,
  IGetIssuedCheckFileResposne,
  IGetTransactions,
  IPurgeTransactionPayload,
  IPurgeTransactionResponse,
} from '../models/Transaction.model'
import { ApiResponse } from '../models/common.model'

const config = { baseURL: process.env.REACT_APP_TRANSACTION_SERVICE_URL || '' }

export const getTransactions = (data: IGetTransactions.Payload): Promise<ApiResponse<IGetTransactions.Response>> => {
  return axiosInstance.post(`/Transactions/filter`, data, config)
}

export const getExceptionProcessing = (data: any): Promise<any> => {
  return axiosInstance.post(`/ExceptionProcessings/filter`, data, config)
}

export const getExceptionDetail = (exceptionId: string, timezoneID: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/ExceptionProcessings/checkExceptionDetail/${exceptionId}?timeZoneId=${timezoneID}`, config)
}

export const makeCheckExceptionDecision = (data: IDecisionPayload): Promise<ApiResponse<any>> => {
  return axiosInstance.post('/ExceptionProcessings/makeCheckDecision', data, config)
}

export const getACHExceptionDetail = (exceptionId: string, timezoneID: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/ExceptionProcessings/achExceptionDetail/${exceptionId}?timeZoneId=${timezoneID}`, config)
}

export const makeAchExceptionDecision = (data: IDecisionPayload): Promise<ApiResponse<any>> => {
  return axiosInstance.post('/ExceptionProcessings/makeAchDecision', data, config)
}

export const checkVerification = (data: ICheckVerificationload): Promise<ApiResponse<any>> => {
  return axiosInstance.post('/CheckVerification/verify', data, config)
}

export const getIssuedcheckFiles = (
  data: IGetIssuedCheckFielPayload,
): Promise<ApiResponse<Array<IGetIssuedCheckFileResposne>>> => {
  return axiosInstance.post('/purgeTransaction/issuedCheck/getFiles', data, config)
}

export const getFileDetail = (data: IGetFileDetailPayload): Promise<ApiResponse<IGetFileDetailResponse>> => {
  return axiosInstance.get(`/purgeTransaction/issuedCheck/getFileDetail/${data.id}`, config)
}

export const purgeTransaction = (data: IPurgeTransactionPayload): Promise<ApiResponse<IPurgeTransactionResponse>> => {
  return axiosInstance.post(`/purgeTransaction/issuedCheck/PurgeFile`, data, config)
}

export const getDownloadStatus = (fileId: string): Promise<ApiResponse<string>> => {
  return axiosInstance.get(`/transactions/getStatus/${fileId}`,config);
}

export const getDownloadPdf = (fileId: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/transactions/downloadPdf/${fileId}`, config)
} 

export const hasExceptionsByClient = (clientId: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/transactions/hasExceptionsByClient/${clientId}`,config);
}

export const hasExceptionsByAccount = (accountId: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/transactions/hasExceptionsByAccount/${accountId}`,config);
}